/**
 * Yüklenen logo/favicon önizlemesi — panel origin + /uploads (nginx proxy)
 */
export function resolveBrandingAssetUrl(branding, type = 'logo') {
  if (!branding) return null;

  const isLogo = type === 'logo';
  const path = isLogo ? branding.logoPath : branding.faviconPath;
  const updatedAt = isLogo ? branding.logoUpdatedAt : branding.faviconUpdatedAt;
  const externalUrl = isLogo ? branding.logo : branding.faviconUrl;

  if (path) {
    const base = typeof window !== 'undefined' ? window.location.origin : '';
    const v = updatedAt ? `?v=${updatedAt}` : '';
    return `${base}${path}${v}`;
  }

  if (externalUrl?.trim()) return externalUrl.trim();
  return null;
}
